import { useNavigate, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import StructuredData from '@/components/base/StructuredData';

const SITE_URL = 'https://sugargoosheet.bar';

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Terms of Service',
  url: SITE_URL + '/terms-of-service',
  description: 'Terms of Service for Sugargoo Sheet — our informational resource platform terms covering acceptance, service nature, disclaimers, and intellectual property.',
  publisher: { '@type': 'Organization', name: 'Sugargoo Sheet' },
};

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50">
      <StructuredData data={webPageSchema} />
      <Navbar />
      <main>
        <div className="pt-24 pb-10 md:pt-28 md:pb-14">
          <div className="max-w-3xl mx-auto px-6 md:px-10">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6 flex-wrap" aria-label="Breadcrumb">
              <a href="/" className="hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap" onClick={(e) => { e.preventDefault(); navigate('/'); }}>
                Home
              </a>
              <i className="ri-arrow-right-s-line w-3 h-3 flex items-center justify-center"></i>
              <span className="text-foreground-400 whitespace-nowrap">Terms of Service</span>
            </nav>

            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-8">Terms of Service</h1>
            <p className="text-sm text-foreground-600 mb-4">Last updated: August 2026</p>

            <div className="space-y-6 text-sm md:text-base text-foreground-700 leading-relaxed">
              <section>
                <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-3">1. Acceptance of Terms</h2>
                <p>By accessing and using sugargoosheet.bar, you accept and agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use our website.</p>
              </section>

              <section>
                <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-3">2. Nature of Service</h2>
                <p>Sugargoo Sheet is an independent informational and educational resource platform. We do not sell products directly, process payments, or facilitate transactions. All product purchases and transactions occur on external websites, primarily kaspreadsheet.com. We are not responsible for the quality, delivery, or any aspect of products purchased through external links.</p>
              </section>

              <section>
                <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-3">3. Disclaimer</h2>
                <p>The information provided on sugargoosheet.bar is for general informational purposes only. While we strive to keep information accurate and up to date, we make no warranties about the completeness, reliability, or accuracy of this information. Users should verify product details, seller information, and pricing before making any purchasing decisions.</p>
              </section>

              <section>
                <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-3">4. External Links</h2>
                <p>Our website contains links to external websites that are not operated by us. We have no control over the content and practices of these sites and cannot accept responsibility for their respective privacy policies or terms.</p>
              </section>

              <section>
                <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-3">5. Intellectual Property</h2>
                <p>All original content on sugargoosheet.bar, including articles, guides, and editorial content, is protected by applicable copyright laws. Product names, trademarks, and brands mentioned on this site are the property of their respective owners.</p>
              </section>

              <section>
                <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-3">6. Changes to Terms</h2>
                <p>We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to the website. Continued use of the website after changes constitutes acceptance of the modified terms.</p>
              </section>
            </div>

            <div className="mt-10 pt-8 border-t border-background-200">
              <div className="flex flex-wrap gap-2">
                <Link to="/" className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-background-100 text-xs font-medium text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-all duration-200 cursor-pointer whitespace-nowrap">
                  <i className="ri-home-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  Home
                </Link>
                <Link to="/sugargoo-spreadsheet-guide" className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-background-100 text-xs font-medium text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-all duration-200 cursor-pointer whitespace-nowrap">
                  Spreadsheet Guide
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}